const wrapper = document.querySelector('.team__round-row');
if (wrapper) {
    function makeActive(id) {
        const roundTitle = wrapper.querySelector(`.team__round-title[data-id=${id}]`);
        const roundPath= wrapper.querySelector(`.line[data-id=${id}]`);
        const roundBarTitle= wrapper.querySelector(`.team__round-bar[data-id=${id}]`);

        wrapper.classList.add('team__round-row_active');
        roundTitle.classList.add('team__round-title_active');
        roundPath.classList.add('line_active');
        roundBarTitle.classList.add('team__round-bar_active');
    }

    function makeClear() {
        const roundTitle = wrapper.querySelectorAll(`.team__round-title_active`);
        const roundPath= wrapper.querySelectorAll(`.line_active`);
        const roundBarTitle= wrapper.querySelectorAll(`.team__round-bar_active`);

        wrapper.classList.remove('team__round-row_active');
        roundTitle.forEach((item) => {
            item.classList.remove('team__round-title_active');
        });
        roundPath.forEach((item) => {
            item.classList.remove('line_active');
        });
        roundBarTitle.forEach((item) => {
            item.classList.remove('team__round-bar_active');
        });
    }

    const elementsForHover = [];
    elementsForHover.push.apply(elementsForHover, wrapper.querySelectorAll(`.line`));
    elementsForHover.push.apply(elementsForHover, wrapper.querySelectorAll(`.team__round-bar`));
    elementsForHover.forEach((item) => {
        item.addEventListener('mouseover', function () {
            makeActive(item.getAttribute('data-id'));
        });

        item.addEventListener('mouseout', function () {
            makeClear(item.getAttribute('data-id'));
        });
    });
}